import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CircleAlert, X } from "lucide-react";
import { BANNER } from "../../motion/transitions";

function BannerBody({ onDismiss, compact }) {
  if (compact) {
    return (
      <div className="flex w-full items-center gap-3 bg-[#F8F5FA] px-4 py-3 lg:rounded-md lg:border-l-[5px] lg:border-primaryText lg:py-4 lg:pl-5 lg:pr-6">
        <CircleAlert
          size={18}
          className="shrink-0 text-primaryText"
          strokeWidth={1.75}
        />
        <p className="flex-1 font-josefin text-xs leading-snug text-secondaryText/80 lg:text-sm">
          <span className="font-semibold text-secondaryText">
            Cette lettre n&apos;a pas de destinataire(s).
          </span>{" "}
          Ajoute-en pour qu&apos;elle puisse leur être transmise.
        </p>
        <button
          type="button"
          onClick={onDismiss}
          className="shrink-0 rounded p-1 text-secondaryText/60 transition hover:text-secondaryText"
          aria-label="Fermer"
        >
          <X size={16} strokeWidth={2} />
        </button>
      </div>
    );
  }

  return (
    <div className="flex w-full items-center justify-between gap-4 rounded-md border-l-[5px] border-primaryText bg-[#F8F5FA] py-4 pl-5 pr-6">
      <div className="flex items-center gap-3 font-josefin text-sm">
        <CircleAlert
          size={20}
          className="shrink-0 text-primaryText"
          strokeWidth={1.75}
        />
        <p className="text-secondaryText/70">
          <span className="font-semibold text-secondaryText">
            Cette lettre n&apos;a pas de destinataire(s).
          </span>{" "}
          Ajoute-en pour qu&apos;elle puisse leur être transmise.
        </p>
      </div>
      <button
        type="button"
        onClick={onDismiss}
        className="shrink-0 rounded p-1 text-secondaryText/60 transition hover:text-secondaryText"
        aria-label="Fermer"
      >
        <X size={18} strokeWidth={2} />
      </button>
    </div>
  );
}

function NoRecipientBanner({ onDismiss, compact = false, visible = true }) {
  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          key="no-recipient-banner"
          initial={BANNER.slideDown.initial}
          animate={BANNER.slideDown.animate}
          exit={BANNER.slideDown.exit}
          transition={BANNER.slideDown.transition}
        >
          <BannerBody onDismiss={onDismiss} compact={compact} />
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default NoRecipientBanner;
